import React from 'react';
import { Group } from '@vx/group';
import { Grid as GridElement } from '@vx/grid';
import { scaleBand } from '@vx/scale';

import { renderWhenTrue } from '../../utils/rendering';
import { numTicksForHeight, numTicksForWidth } from './charts.helper';

export const Grid = ({ top = 0, left = 0, width, height, xScale, yScale, config, children, ...props }) => {
  const scale = scaleBand({
    range: [0, width],
    domain: [],
  });

  const renderGrid = renderWhenTrue(() => (
    <GridElement
      width={width}
      height={height}
      xScale={xScale || scale}
      yScale={yScale || scale}
      rowLineStyle={config.gridRowLineStyle}
      columnLineStyle={config.gridColumnLineStyle}
      numTicksRows={numTicksForHeight(height)}
      numTicksColumns={numTicksForWidth(width)}
      {...props}
    />
  ));

  return (
    <Group top={top} left={left}>
      <rect width={width} height={height} fill={config.gridBackground} />
      {children}
      {renderGrid(config.gridVisible)}
    </Group>
  );
};
